import axios from 'axios';
import { ADD_TO_CART, REMOVE_CART_ITEM, SAVE_SHIPPING_INFO } from '../constants/cartConstants';
import { URL } from '../../Routing';
import Cookies from 'universal-cookie';

const getHeader = () => {
    return { headers: { Authorization: new Cookies().get('token') } };
};

export const addToCart = (id, quantity) => async (dispatch, getState) => {
    const data = await axios.get(`${URL}/api/v1/product/${id}`, getHeader());
    dispatch({
        type: ADD_TO_CART,
        payload: {
            product: data.data.product._id,
            name: data.data.product.name,
            price: data.data.product.price,
            image: data.data.product.images[0].url,
            stock: data.data.product.Stock,
            quantity,
        },
    });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
};

export const removeCartItem = (id) => async (dispatch, getState) => {
    dispatch({
        type: REMOVE_CART_ITEM,
        payload: id,
    });

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
};

export const saveShippingInfo = (data) => async (dispatch) => {
    dispatch({
        type: SAVE_SHIPPING_INFO,
        payload: data,
    });

    localStorage.setItem('shippingInfo', JSON.stringify(data));
};
